import React, {useState} from 'react';
import styled from 'styled-components'
import useResponsive from "../../hooks/responsive";

export default function CareerSelector({career}) {
    const [isSelecting, setIsSelecting] = useState(false)
    const [isMobile, maxWidthContainer] = useResponsive()

    const select = () => {
        location.href = `/select-career/${career.slug}`
    }
    return (
        <Container isMobile={isMobile}>
            <ButtonSelect isMobile={isMobile} active={isSelecting} onClick={() => setIsSelecting(!isSelecting)}>{career.name}</ButtonSelect>
            {isSelecting && (
                <SelectingContainer isMobile={isMobile}>
                    <ButtonCancel onClick={() => setIsSelecting(false)}>Cancelar</ButtonCancel>
                    <ButtonConfirm onClick={select}>Confirmar</ButtonConfirm>
                </SelectingContainer>
            )}

        </Container>
    )
}

const SelectingContainer = styled.div`

    display: flex;
    flex-direction: row;
    justify-content: ${props => props.isMobile ? 'space-between' : 'flex-start'};

`

const ButtonConfirm = styled.div`
     border: 1px solid #FA9F63;
    padding: 8px;
    margin-top: 12px;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    background-color: #FA9F63;

    &:hover {
        color: #FA9F63;
        background-color: transparent;
    }
`

const ButtonCancel = styled.div`
     border: 1px solid #8B2635;
    padding: 8px;
    margin-top: 12px;
    border-radius: 4px;
    color: white;
    background-color: #8B2635;

    cursor: pointer;
    margin-right: 4px;

    &:hover {
        color: #8B2635;
        background-color: transparent;
    }
`

const Container = styled.div`
    display: flex;
    flex-direction: ${props => props.isMobile ? 'column' : 'row'};
    justify-content: space-between;
    margin-top:16px;

`

const ButtonSelect = styled.div`
    border: 1px solid ${props => props.active ? '#FA9F63' : 'white'};
    padding: 8px;
    margin-top: 12px;
    border-radius: 4px;
    color: ${props => props.active ? '#FA9F63' : 'white'};
    cursor: pointer;
    text-align: ${props => props.isMobile ?  'center' : 'left'};

    &:hover {
        border: 1px solid #FA9F63;
        color: #FA9F63;
    }
`
